package com.myfield.app.domain

import com.myfield.app.util.Resource

enum class Feature(
    val title: String,
    val subtitle: String,
    val icon: String,
) {
    Fields(
        title = "Поля",
        subtitle = "Поля, сезони та культури — все в одному місці",
        icon = Resource.Icon.FIELDS
    ),

    Expenses(
        title = "Витрати",
        subtitle = "Повний облік усіх фінансових операцій господарства",
        icon = Resource.Icon.EXPENSE
    ),

    Inventory(
        title = "Запаси",
        subtitle = "Актуальні залишки матеріалів, палива та врожаю",
        icon = Resource.Icon.INVENTORY
    ),

    Analytics(
        title = "Аналітика",
        subtitle = "Прибутковість, витрати на гектар та підсумки кожного сезону",
        icon = Resource.Icon.ANALYTICS
    ),

    Precipitation(
        title = "Опади",
        subtitle = "Записуйте опади для точного планування робіт",
        icon = Resource.Icon.PRECIPITATION
    ),

    Workers(
        title = "Працівники",
        subtitle = "Усі ваші партнери — співробітники, орендодавці та кредитори",
        icon = Resource.Icon.WORKERS
    ),
}